import React, { useCallback, useRef } from 'react';
import { Helmet } from 'react-helmet';
import DemoGrid from '../../components/DemoGrid/DemoGrid';
import Footer from '../../components/Footer/Footer';
import Hero2025 from '../../components/Hero2025/Hero2025';
import './LandingPage.css';

const LandingPage: React.FC = () => {
  console.log('gioi thieu');

  // Ref cho falling pixels container để tránh re-render
  const fallingPixelsContainerRef = useRef<HTMLDivElement>(null);

  // Array chứa các pattern màu sắc khác nhau cho demo-grid - sử dụng useMemo để tránh tạo lại
  const listDemo = [
    // Pattern 1: Đỏ vàng trắng
    Array(64)
      .fill('')
      .map((_, i) => {
        if (i % 3 === 0) return '#ff4444'; // Đỏ
        if (i % 3 === 1) return '#ffdd00'; // Vàng
        return '#ffffff'; // Trắng
      }),
    // Pattern 2: Xanh dương và xanh lá
    Array(64)
      .fill('')
      .map((_, i) => {
        if (i % 4 === 0) return '#4ecdc4'; // Xanh lá
        if (i % 4 === 1) return '#45b7d1'; // Xanh dương
        if (i % 4 === 2) return '#96ceb4'; // Xanh mint
        return '#2c3e50'; // Xanh đậm
      }),
    // Pattern 3: Hồng và tím
    Array(64)
      .fill('')
      .map((_, i) => {
        if (i % 5 === 0) return '#ff6b6b'; // Hồng
        if (i % 5 === 1) return '#a55eea'; // Tím
        if (i % 5 === 2) return '#fd79a8'; // Hồng nhạt
        if (i % 5 === 3) return '#6c5ce7'; // Tím nhạt
        return '#e84393'; // Hồng đậm
      }),
    // Pattern 4: Gradient từ đỏ đến vàng
    Array(64)
      .fill('')
      .map((_, i) => {
        const hue = 0 + (i * 360) / 64; // Từ đỏ (0) đến vàng (60)
        return `hsl(${hue}, 70%, 60%)`;
      }),
    // Pattern 5: Random màu sắc
    Array(64)
      .fill('')
      .map((_, i) => {
        const colors = [
          '#ff4444',
          '#ffdd00',
          '#4ecdc4',
          '#45b7d1',
          '#ff6b6b',
          '#a55eea',
          '#fd79a8',
          '#6c5ce7',
        ];
        return colors[i % colors.length];
      }),
  ];

  // Function để tạo pixel mới - sử dụng useCallback để tránh tạo lại function
  const createNewPixel = useCallback(() => {
    const newPixel = document.createElement('div');
    newPixel.className = 'falling-pixel';
    newPixel.style.left = `${Math.random() * 100}%`;
    newPixel.style.animationDelay = `${Math.random() * 10}s`;
    newPixel.style.animationDuration = `${8 + Math.random() * 4}s`;

    // Thêm event listener cho pixel mới (DOM event)
    newPixel.addEventListener('mouseenter', (e: Event) => {
      const pixel = e.currentTarget as HTMLElement;
      const rect = pixel.getBoundingClientRect();

      // Tạo element nổ
      const explosion = document.createElement('div');
      explosion.className = 'explosion-effect';
      explosion.style.left = `${rect.left}px`;
      explosion.style.top = `${rect.top}px`;
      document.body.appendChild(explosion);

      // Thêm class fade out
      pixel.classList.add('fading');

      // Remove explosion sau 500ms
      setTimeout(() => {
        explosion.remove();
      }, 500);

      // Remove pixel cũ và tạo pixel mới sau 500ms
      setTimeout(() => {
        pixel.remove(); // Remove pixel cũ
        if (fallingPixelsContainerRef.current) {
          const newPixel = createNewPixel();
          fallingPixelsContainerRef.current.appendChild(newPixel);
        }
      }, 500);
    });

    return newPixel;
  }, []);

  // Function xử lý hover pixel (React event) - sử dụng useCallback để tránh tạo lại function
  const handlePixelHover = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      const pixel = e.currentTarget;
      const rect = pixel.getBoundingClientRect();

      // Tạo element nổ
      const explosion = document.createElement('div');
      explosion.className = 'explosion-effect';
      explosion.style.left = `${rect.left}px`;
      explosion.style.top = `${rect.top}px`;
      document.body.appendChild(explosion);

      // Thêm class fade out
      pixel.classList.add('fading');

      // Remove explosion sau 500ms
      setTimeout(() => {
        explosion.remove();
      }, 500);

      // Remove pixel cũ và tạo pixel mới sau 500ms
      setTimeout(() => {
        pixel.remove(); // Remove pixel cũ
        if (fallingPixelsContainerRef.current) {
          const newPixel = createNewPixel();
          fallingPixelsContainerRef.current.appendChild(newPixel);
        }
      }, 500);
    },
    [createNewPixel]
  );

  return (
    <>
      <Helmet>
        <title>Giới thiệu pixel.io.vn</title>

        <meta name="description" content="Giới thiệu về pixel.io.vn" />

        {/* og */}
        <meta property="og:title" content="Giới thiệu pixel.io.vn" />
      </Helmet>
      <div className="gioi-thieu">
        {/* Hero */}
        <Hero2025 />

        {/* Reversed Diagonal Section */}
        <section className="diagonal-section-reversed">
          <div className="diagonal-content-reversed">
            <div className="left-panel-image">
              <img
                src="./images/gioi-thieu/pixelland.png"
                alt="Vietnam in Pixel Community"
                className="section-image"
              />
              <div className="image-overlay-effect"></div>
            </div>
            <div className="right-panel-text">
              <h3>Cho mọi người thấy sự sáng tạo của bạn</h3>
              <p>Hàng ngàn ô vuông đang chờ bạn tạo nên những tác phẩm độc đáo.</p>
              <div className="stats-container">
              
                <div className="stat-item">
                  <span className="stat-number">10x10 </span>
                  <span className="stat-label">Pixel mỗi ô</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">256</span>
                  <span className="stat-label">Màu sắc</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Interactive Map Preview */}
        <section className="map-preview">
          <div className="gioi-thieu-map-container">
            <div className="gioi-thieu-map-outline">
              <div className="gioi-thieu-map-pixels">
                <div className="map-container">
                  <img
                    src="./images/gioi-thieu/vnblank.png"
                    alt="Bản đồ Việt Nam"
                    className="map-image"
                  />
                  <div
                    className="map-fill-overlay"
                    style={{ height: '22.22%' }}
                  ></div>
                </div>
              </div>
            </div>
            <div className="gioi-thieu-map-info">
              <h3>Tiến trình hiện tại</h3>
              <p>1,000 ô đã được mua (22%)</p>
            </div>
          </div>
        </section>

        {/* Floating CTA */}
        <section className="floating-cta">
          <div className="pixel-grid">
            {[...Array(40)].map((_, i) => (
              <div
                key={i}
                className={`pixel ${i % 5 === 0 ? 'new-row' : ''}`}
              ></div>
            ))}
          </div>

          <div className="cta-container">
            <div className="cta-text">
              <h2>Sẵn sàng chưa?</h2>
              <p>
                Để lại dấu ấn của bạn<br />
                trên lịch sử internet Việt Nam
              </p>
            </div>
            <div className="cta-buttons">
              <a href='/2025' className="pixel-btn primary">Tham gia ngay</a>
            </div>
          </div>
          <div className="floating-elements">
            <div className="floating-pixel"></div>
            <div className="floating-pixel"></div>
            <div className="floating-pixel"></div>
          </div>
        </section>

        {/* Falling Pixels Effect */}
        <div
          className="falling-pixels-container"
          ref={fallingPixelsContainerRef}
        >
          {[...Array(10)].map((_, i) => (
            <div
              key={i}
              className="falling-pixel"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 10}s`,
                animationDuration: `${8 + Math.random() * 4}s`,
              }}
              onMouseEnter={handlePixelHover}
            >
              {/* Pixel vuông với màu ngẫu nhiên */}
            </div>
          ))}
        </div>
        {/* Footer Component */}
        <Footer />
      </div>
    </>
  );
};

export default LandingPage;
